/**
 * LegalTranslationServicesPage — iter-272 (Feb 2026)
 * ==================================================
 * Replaces the flat topic-list `LegalTranslationServices.js` page with
 * the SAME cards + manage-required-documents flow used by
 * "طلبات التأشيرة والهوية". Powered by the shared ServiceCatalogPage
 * component.
 *
 * Route:  /control/cloudgm/legal-translation           → list
 *         /control/cloudgm/legal-translation/:id       → detail
 */
import ServiceCatalogPage from './ServiceCatalogPage';

export default function LegalTranslationServicesPage() {
  return (
    <ServiceCatalogPage
      category="legal_translation"
      titleAr="خدمات الترجمة القانونية"
      titleEn="Legal Translation Services"
      subtitleAr="إدارة خدمات الترجمة القانونية والأوراق المطلوبة"
      subtitleEn="Manage legal translation services and required documents"
      accentColor="rose"
      backPath="/control/cloudgm"
      detailPathBase="/control/cloudgm/legal-translation"
      testIdPrefix="legal-trans"
      breadcrumb={[
        { labelAr: 'CLOUDGM FZ LLC', labelEn: 'CLOUDGM FZ LLC', path: '/dashboard?view=cloudgm' },
        { labelAr: 'منصة العملاء', labelEn: 'Customers Platform', path: '/dashboard?view=cloudgm&platform=customers' },
        { labelAr: 'التحكم والمعلومات (منصة العملاء)', labelEn: 'Control & Info (Customers)', path: '/control/cloudgm' },
        { labelAr: 'خدمات الترجمة القانونية', labelEn: 'Legal Translation Services' },
      ]}
    />
  );
}
